module.exports = __webpack_public_path__ + "static/media/Nuoc.8cb76971.svg";